<script lang="ts">
    import dayjs from 'dayjs';
    import {
        VpReturnIcon,
        VpCalendarIcon,
        VpGroupIcon,
        VpMapPinIcon,
        VpRunIcon,
        VpRefreshIcon,
    } from '@decathlon-experience/icons/svelte';

    import Button from '$saga/components/Button.svelte';
    import { resetLabels, resetValues } from '$saga/views/Search/utils';
    import {
        filtersContext,
        filteredToursCount,
    } from '$saga/views/Search/store';
    import { FilterType } from '../types';

    export let handleSelectedFilter: (filterType: FilterType) => void;

    const handleResetValues = () => {
        $filtersContext.formLabels = resetLabels();
        $filtersContext.formValues = resetValues();
    };
</script>

<div class="flex h-full w-full flex-col">
    <div class="flex h-full flex-col gap-m">
        <span class="w-full px-m pt-m text-center"
            >Renseignez un ou plusieurs critères</span
        >
        <button
            type="button"
            class="flex w-full items-center justify-between self-center bg-container-quiet px-xs py-l hover:bg-container-commercial-neutral"
            on:click={() => handleSelectedFilter(FilterType.SPORT)}
        >
            <span class="flex items-center gap-xs">
                <VpRunIcon class="size-l" />
                Sport
            </span>
            <span class="text-sm">
                {#if $filtersContext.formLabels.theme.length > 0}
                    <span class="truncate text-content-brand">
                        {$filtersContext.formLabels.theme
                            .join(', ')
                            .replace('all', 'Tous')}
                    </span>
                {:else}
                    <span class="text-content-quiet">Ajoutez des sports</span>
                {/if}
            </span>
        </button>

        <button
            type="button"
            class="flex w-full items-center justify-between self-center bg-container-quiet px-xs py-l hover:bg-container-commercial-neutral"
            on:click={() => handleSelectedFilter(FilterType.DESTINATION)}
        >
            <span class="flex items-center gap-xs">
                <VpMapPinIcon class="size-l" />
                Destination
            </span>
            <span class="text-sm">
                {#if $filtersContext.formLabels.destination.length > 0}
                    <span class="truncate text-content-brand">
                        {$filtersContext.formLabels.destination
                            .join(', ')
                            .replace('all', 'Toutes')}
                    </span>
                {:else}
                    <span class="text-content-quiet"
                        >Ajoutez des destinations</span
                    >
                {/if}
            </span>
        </button>

        <button
            type="button"
            class="flex w-full items-center justify-between self-center bg-container-quiet px-xs py-l hover:bg-container-commercial-neutral"
            on:click={() => handleSelectedFilter(FilterType.STARTDATE)}
        >
            <span class="flex items-center gap-xs">
                <VpCalendarIcon class="size-l" />
                Date de départ
            </span>
            <span class="text-sm">
                {#if $filtersContext.formLabels.startDate != null}
                    <span class="truncate text-content-brand">
                        {#if $filtersContext.formLabels.endDate}
                            {dayjs($filtersContext.formLabels.endDate).format(
                                'MMM YYYY',
                            )}
                        {:else}
                            {dayjs(
                                $filtersContext.formLabels.startDate.toString(),
                            ).format('DD/MM/YYYY')}
                        {/if}
                    </span>
                {:else}
                    <span class="text-content-quiet">Ajoutez un départ</span>
                {/if}
            </span>
        </button>
        <button
            type="button"
            class="flex w-full items-center justify-between self-center bg-container-quiet px-xs py-l hover:bg-container-commercial-neutral"
            on:click={() => handleSelectedFilter(FilterType.PAX)}
        >
            <span class="flex items-center gap-xs">
                <VpGroupIcon class="size-l" />
                Voyageurs
            </span>
            <span class="text-sm">
                {#if $filtersContext.formLabels.nbPax !== '' && $filtersContext.formLabels.nbPax !== '0'}
                    <span class="truncate text-content-brand">
                        {$filtersContext.formLabels.nbPax}
                        {Number($filtersContext.formLabels.nbPax) > 1
                            ? 'voyageurs'
                            : 'voyageur'}
                    </span>
                {:else}
                    <span class="text-content-quiet">Ajoutez un départ</span>
                {/if}
            </span>
        </button>
    </div>
    <div
        class="sticky bottom-0 left-0 flex w-full justify-between border-t border-solid border-border-quiet bg-white px-l py-s desktop:px-3xl"
    >
        <Button
            size="small"
            intent="secondary"
            shape="rounded"
            type="button"
            on:click={() => handleResetValues()}
            startIcon={VpReturnIcon}>Tout effacer</Button
        >

        <Button
            type={$filtersContext.isHomePage ? 'submit' : 'button'}
            form="travel-search-engine-form"
            size="small"
            shape="rounded"
            on:click={() => {
                if (!$filtersContext.isHomePage) {
                    const form = document.getElementById(
                        'travel-search-engine-form',
                    );
                    if (form) {
                        setTimeout(() => {
                            form.dispatchEvent(
                                new Event('submit', {
                                    bubbles: true,
                                    cancelable: true,
                                }),
                            );
                        }, 0);
                    }
                }
            }}
        >
            {#if $filtersContext.isSubmitting}
                <VpRefreshIcon class="size-m animate-spin " />
            {:else}
                Rechercher {#if $filteredToursCount !== null}
                    ({$filteredToursCount}){/if}
            {/if}
        </Button>
    </div>
</div>
